import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import LoadingSpinner from '@ui/loading-spinner/loading-spinner';
import TemplatePreviewCard from './template-preview-card';
import classes from '../create-campaign-flow.module.css';
import type { CampaignTemplate } from '@/connection/campaigns/fetch-campaign-templates';
import { campaignTemplatesMap } from '../../templates';

interface TemplateGridProps {
  templates: CampaignTemplate[];
  onEditTemplate: (templateUuid: string) => void;
  onPreviewTemplate: (templateUuid: string) => void;
  isCreating: boolean;
  loading?: boolean;
  emptyMessage?: string;
}

export default function TemplateGrid({
  templates,
  onEditTemplate,
  onPreviewTemplate,
  isCreating,
  loading,
  emptyMessage = 'No templates available for this category',
}: TemplateGridProps) {
  if (loading) {
    return (
      <div className={classes.templateGrid}>
        <Container className="flex-column ai-center jc-center" padding="80px">
          <LoadingSpinner />
        </Container>
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div className={classes.templateGrid}>
        <Container className="flex-column ai-center jc-center" padding="80px">
          <Text className="H5" design="GlobalIcoText3">
            {emptyMessage}
          </Text>
        </Container>
      </div>
    );
  }

  return (
    <div className={classes.templateGrid}>
      {templates.map((template) => (
        <TemplatePreviewCard
          key={template.uuid}
          template={{ ...template, component: campaignTemplatesMap.get(template.uuid)! }}
          onEdit={onEditTemplate}
          onPreview={onPreviewTemplate}
          isCreating={isCreating}
        />
      ))}
    </div>
  );
}
